import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartnersComponent} from './partners/partners.component';
import {RouterModule} from '@angular/router';
import {EditPartnersComponent} from './edit-partners/edit-partners.component';
import {ShowPartnersComponent} from './show-partners/show-partners.component';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxDropdownModule} from "@allianz/ng-aquila/dropdown";
import {NxSwitcherModule} from "@allianz/ng-aquila/switcher";
import {NxImageModule} from "@allianz/ng-aquila/image";
import {PipeModule} from "../../pipe/pipe.module";
import {NxListModule} from "@allianz/ng-aquila/list";
import {NxAccordionModule} from "@allianz/ng-aquila/accordion";


@NgModule({
  declarations: [
    PartnersComponent,
    EditPartnersComponent,
    ShowPartnersComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        NxCardModule,
        NxIconModule,
        ComponentsModule,
        NxHeadlineModule,
        NxGridModule,
        NxButtonModule,
        NxFormfieldModule,
        NxInputModule,
        FormsModule,
        NxDropdownModule,
        NxSwitcherModule,
        NxImageModule,
        PipeModule,
        NxListModule,
        NxAccordionModule,
    ]
})
export class PartnerModule {
}
